
      import { defu } from 'defu'
      const matcher = /* @__PURE__ */ (() => { const $0={redirect: "/sitemap_index.xml"},$1={};; return (m,p)=>{let r=[];if(p.charCodeAt(p.length-1)===47)p=p.slice(0,-1)||"/";if(p==="/sitemap.xml"){r.unshift({data:$0});}else if(p==="/_nuxt"){r.unshift({data:$1});}return r;}})()
      export default (path) => defu({}, ...matcher('', path).map(r => r.data).reverse())
      